import { setTitle } from "../../../helpers/MetaTag";
import PlaceOrderContent from "../../../components/sections/front/User/PlaceOrderContent";


const PlaceOrder = () => {
  setTitle("Memory Doodle | Choose Photos");
  return (
    <PlaceOrderContent />
  );
};



export default PlaceOrder;
